import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { ProjectId } from 'api/models';
import { AssigneeField, UserId } from 'components/organisms/tasks/fields';
import { getFilterFunction } from 'components/organisms/tasks/get-filter-function';
import { to_query } from 'components/pages/filter-transformer';
import { ofNullable } from 'core/maybe';
import { RootState } from 'data';
import { TaskField } from 'stores/fields';
import { TasksStore } from 'stores/tasks';
import { constructTaskFilterUrl } from '../../../utils/construct-task-filter-url';
import { useSortByCountGroupedArray } from '../avatar-count-list';
import { restrictToUser } from '../restrict-to-user';
import { TasksCount } from '../tasks-count';
import { getCompletedTasksFilter } from './use-completed-tasks';

export const Count: FC<{
  projectId: number;
  taskFields: Record<string, TaskField>;
}> = ({ projectId, taskFields }) => {
  const tasksStore = useSelector(({ tasks_v2 }: RootState) => tasks_v2);
  const tasks =
    TasksStore.ofProjectId(ProjectId(projectId))(tasksStore)[1] ?? [];
  const filter = getCompletedTasksFilter(taskFields);
  const filterFunction = getFilterFunction(filter);
  const data = tasks.filter(
    (x) => filterFunction?.(x as unknown as Record<string, unknown>) ?? true,
  );
  const sortedList = useSortByCountGroupedArray(data);
  const assignee = ofNullable(taskFields.assignee as AssigneeField);
  const forUser = restrictToUser(assignee)(filter);
  const groups = sortedList.map((value) => ({
    user: value.avatar,
    count: value.count,
    url: constructTaskFilterUrl(
      projectId,
      `${to_query(forUser(UserId(value.avatar.userId)))}`,
    ),
  }));

  return (
    <TasksCount
      color="var(--green-50)"
      count={data.length}
      groups={groups}
      url={constructTaskFilterUrl(projectId, `${to_query(filter)}`)}
    />
  );
};
